import React from 'react';

export const Loading = () => (
    <div className="py-4 space-y-4 w-full" data-testid="Loading">
        <div className="animate-pulse h-4 bg-gray-200 rounded" />
        <div className="animate-pulse h-4 w-5/6 bg-gray-200 rounded" />
        <div className="animate-pulse h-4 w-4/6 bg-gray-200 rounded" />
    </div>
);
